import styled from 'styled-components/macro';
import { Message } from './Message';

export const HelperText = styled(Message)`
  position: absolute;
  bottom: -1em;
`;
